import { render, staticRenderFns } from "./communityMember.vue?vue&type=template&id=624c87c4&scoped=true"
import script from "./communityMember.vue?vue&type=script&lang=js"
export * from "./communityMember.vue?vue&type=script&lang=js"
import style0 from "./communityMember.vue?vue&type=style&index=0&id=624c87c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c87c4",
  null
  
)

export default component.exports